import {Extension} from "./Extension";
import {Log, LogTag} from "../Log";
import {AsyncSubject, Observable, of, Subject} from "rxjs";

export class ChromeExtension extends Extension {
  constructor() {
    super();
    const logInfo = Log.getLogInfo("ChromeExtension", "constructor", []);
    if (this.isInstalled) {
      window.addEventListener("message", (event) => { // Only accept messages from the same frame
        if (event.source !== window) {
          return;
        }
        const message = event.data;
        if (typeof message !== "object" || message === null || !!message.source && message.source !== "signPlayerWatchdog") {
          return;
        }
        Log.d(logInfo, LogTag.CHROME_EXTENSION, 'Step 12: receive result from content script. ' + JSON.stringify(message));
        const obs$ = this.messageMap[message.messageId];
        if (obs$ != null) {
          obs$.next(message.result);
          obs$.complete();
          delete this.messageMap[message.messageId];
        }
      });
    }
  }

  call(command, args=null): Observable<any> {
    const logInfo = Log.getLogInfo("ChromeExtension", "call", [command, args]);
    if (this.isInstalled) {
      this.lastId++;
      const messageId = this.lastId.toString();
      const message = {source: "signPlayerPwa", messageId: messageId, command: command};
      if (args != null) {
        for (const key in args) {
          message[key] = args[key];
        }
      }

      const obs$ = this.messageMap[messageId] = new AsyncSubject();
      Log.d(logInfo, LogTag.CHROME_EXTENSION, 'Step-1 Player: send message to Chrome content script.');
      window.postMessage(message, "*");
      return obs$;
    } else {
      return of(null);
    }
  }
}
